import { createRoot } from 'react-dom/client';
import { HashRouter as Router } from "react-router-dom";

import App from './App';
import * as serviceWorker from './serviceWorker';

import './assets/scss/style.scss';

// OFFLINE MODE - commented out for local development
// import { Amplify } from 'aws-amplify';
// import awsconfig from './aws-exports';
// Amplify.configure(awsconfig);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Router>
    <App />
  </Router>
);

serviceWorker.unregister();
